export default "__VITE_ASSET__DnQcWCUa__"